import { Injectable } from '@angular/core';
import { Observable, Subject, throwError } from 'rxjs';
import { HttpErrorResponse, HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';


@Injectable({
    providedIn: 'root'
})
export class FileUploadService {
    public baseURL = environment.apiUrl;
    public baseURI = '/aipo/ticket/analysis/api';

    public emitClearFileUploadTable = new Subject<string>();
    public emitClearFileUploadTable$: Observable<string> = this.emitClearFileUploadTable.asObservable();

    public emitSelectedDropdownList = new Subject<any>();
    public emitSelectedDropdownList$: Observable<string> = this.emitSelectedDropdownList.asObservable();

    public staticTableSelectedDropdownList: any = [];

    constructor(private http: HttpClient) {}

    /**
	 *
	 * this methid will make an API Call to generate Test Data
	 * @param {FormData} payload
	 * @return {*}  {Observable <FormData>}
	 * @memberof FileUploadService
	 */
    public validateFile(payload: FormData): Observable<any> {
      const url = `${this.baseURL}${this.baseURI}/validate`; // Update the endpoint accordingly

      return this.http.post(url, payload);
    }

      /**
   * This method will make an API call to submit the file.
   * @param {FormData} payload
   * @return {Observable<any>}
   * @memberof FileUploadService
   */
  public submitFile(payload: FormData): Observable<any> {
    const url = `${this.baseURL}${this.baseURI}/submit`; // Update the endpoint accordingly

    return this.http.post(url, payload);
  }

    /**
	 *
	 * this method is used for error handling
	 * @private
	 * @param {HttpErrorResponse} error
	 * @return {*}
	 * @memberof FileUploadService
	 */
    private errorMgmt(error: HttpErrorResponse): any {
        let errorMessage = '';

        if (error.error instanceof ErrorEvent) {
            // get client-side error
            errorMessage = error.error.message;
        } else {
            // get server-side error
            errorMessage = `Error Code: ${error.status}\nMessage: ${error.message}`;
        }

        return throwError(errorMessage);
    }

    // clearFileUploadTable() {
    //     // this.emitClearFileUploadTable.next();
    // }

    selectedDropdownList(selectedList: any) {
        this.emitSelectedDropdownList.next(selectedList);
    }

    uploadFile(file: File) {
      const formData: FormData = new FormData();
      formData.append('file', file, file.name);

      return this.http.post('/your-upload-endpoint', formData);
    }
}
